import { ReloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';

function ResetSearchButton({ reset, className = '', ...props }) {
  return (
    <Button
      className={'gSemiBold sb-blue-500 hover:sb-blue-700 brFull ' + className}
      onClick={reset}
      {...props}
    >
      <ReloadOutlined className='grey-900' />{' '}
      <span className=' fs-14 txt-nowrap'>Reset Search</span>
    </Button>
  );
}

export default ResetSearchButton;
